import React, { useState } from "react"
import AccordionItem from "../../atoms/accordion-item/AccordionItem"
// import "./Accordion.css"

export interface IAccordionProps {
  data: {
    question: string
    answer: string
  }[]
}

export default function Accordion({ data }: IAccordionProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  return (
    <div className="bf-faq-wrapper" id="help">
      {data.map((faq, index) => (
        <AccordionItem
          key={index}
          question={faq.question}
          answer={faq.answer}
          isActive={activeIndex === index}
          onClick={() => setActiveIndex(activeIndex === index ? null : index)}
        />
      ))}
    </div>
  )
}
